import Btn from '@components/Btn';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { HEADER_LOGIN_OR_REGISTER_BUTTON, VERSION_LITE } from '@lib/constants';

import { useI18n } from '@lib/i18n';
import { isKioskEnabled } from '@lib/kiosk';

export default function LoginOrRegister({ classes, toggleMenuState = false }) {
	const router = useRouter();
	const { t } = useI18n();

	const { authenticated, isOnline, authStatus } = useSelector((state) => state.user);

	const hideHeaderButtonsForViews = ['/auth/login', '/auth/register'];

	if (hideHeaderButtonsForViews.includes(router.pathname)) {
		return;
	}

	if (VERSION_LITE) {
		return;
	}

	if (isOnline && authenticated) {
		return;
	}

	if (isKioskEnabled()) {
		return;
	}

	// Set some context of where to send the user back to after whatever they did was successful
	let contextualSuccessRedirect = '';

	switch (router.pathname) {
		case '/':
			contextualSuccessRedirect = '';
			break;
		case '/overview':
			contextualSuccessRedirect = 'overview';
			break;
		case '/personalise':
			contextualSuccessRedirect = 'personalise';
			break;
		default:
			contextualSuccessRedirect = '';
			break;
	}

	let routerUrl = '/auth/login';
	if (contextualSuccessRedirect) {
		routerUrl = routerUrl + '?context=' + contextualSuccessRedirect;
	}

	const loginAction = () => {
		if (toggleMenuState) {
			toggleMenuState(false);
		}

		router.push(routerUrl);
	};

	if (authStatus === 'pending') {
		const pendingClasses = Array.isArray(classes) ? [...classes, 'skeleton'] : ['skeleton'];

		return (
			<Btn
				onClick={() => {}} // do nothing while pending
				customClass={pendingClasses}
				className={pendingClasses.join(' ')}
			>
				<svg className="stickyOnly" viewBox="0 0 496 512" width="24" height="24">
					<path
						fill="currentColor"
						d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
					/>
				</svg>
			</Btn>
		);
	}

	return (
		<Btn onClick={() => loginAction()} customClass={classes} className={classes.join(' ')}>
			<svg className="stickyOnly" viewBox="0 0 496 512" width="24" height="24">
				<path
					fill="currentColor"
					d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
				/>
			</svg>
			{t('header.login_or_register', HEADER_LOGIN_OR_REGISTER_BUTTON)}
		</Btn>
	);
}
